export const url_api = process.env.REACT_APP_API_URL; // 'https://testapi.green-up.xyz/api/';
export const url = process.env.REACT_APP_API_IMG; // 'https://testapi.green-up.xyz/';
export const authConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',
};

export const farmConstants = {
    SET_FARM: 'SET_FARM',
    GET_FARM: 'GET_FARM'
}
